import { Injectable } from '@angular/core';
import { EditorJsonModel } from './editor.json.model';
import { AppCollection } from '../app.config';
import { BaseCollectionService } from '../core/jsonApi/BaseCollectionService';

@Injectable({
  providedIn: 'root'
})
export class EditorService extends BaseCollectionService<EditorJsonModel, AppCollection> {
  protected ctor = EditorJsonModel;
}
